var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopupWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5099 6.35L13.5699 2.92C12.5999 2.36 11.3999 2.36 10.4199 2.92L4.48992 6.35C3.51992 6.91 2.91992 7.95 2.91992 9.08V15.92C2.91992 17.04 3.51992 18.08 4.48992 18.65L10.4299 22.08C11.3999 22.64 12.5999 22.64 13.5799 22.08L19.5199 18.65C20.4899 18.09 21.0899 17.05 21.0899 15.92V9.08C21.0799 7.95 20.4799 6.92 19.5099 6.35ZM11.2499 8.25C11.2499 7.84 11.5899 7.5 11.9999 7.5C12.4099 7.5 12.7499 7.84 12.7499 8.25V13.5C12.7499 13.91 12.4099 14.25 11.9999 14.25C11.5899 14.25 11.2499 13.91 11.2499 13.5V8.25ZM12.9199 17.13C12.8699 17.25 12.7999 17.36 12.7099 17.46C12.5199 17.65 12.2699 17.75 11.9999 17.75C11.8699 17.75 11.7399 17.72 11.6199 17.67C11.4899 17.62 11.3899 17.55 11.2899 17.46C11.1999 17.36 11.1299 17.25 11.0699 17.13C11.0199 17.01 10.9999 16.88 10.9999 16.75C10.9999 16.49 11.0999 16.23 11.2899 16.04C11.3899 15.95 11.4899 15.88 11.6199 15.83C11.9899 15.67 12.4299 15.76 12.7099 16.04C12.7999 16.14 12.8699 16.24 12.9199 16.37C12.9699 16.49 12.9999 16.62 12.9999 16.75C12.9999 16.88 12.9699 17.01 12.9199 17.13Z",
    fill: "#0C5EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupWarningIcon);
export default __webpack_public_path__ + "static/media/popup-warning-icon.176483cd556aa80e9aca561e95ea9b29.svg";
export { ForwardRef as ReactComponent };